import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from 'src/shared/components/ui/form'

import { Textarea } from '../ui/textarea'

export const FormTextarea = ({
  name,
  label,
  description,
  methods,
  placeholder,
  className = '',
  rows = 4,
}: {
  name: string
  label?: string | React.ReactNode
  description?: string
  methods: UseFormReturn<any>
  placeholder?: string
  className?: string
  rows?: number
}) => {
  return (
    <FormField
      control={methods.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormControl>
            <Textarea
              {...field}
              label={label}
              placeholder={placeholder}
              className="text-xs"
              rows={rows}
            />
          </FormControl>

          {description && (
            <FormDescription className="text-xs text-muted-foreground">
              {description}
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
